import React from 'react';

export interface SecondaryStructureLinkProps {
  dg: number | null;
  onClick: () => void;
}

export default function SecondaryStructureLink({dg, onClick}: SecondaryStructureLinkProps): JSX.Element {
  return dg == null ? <div className="spinner" /> : <a onClick={onClick}>{dg}</a>;
}
